// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tr-container {
  padding: 24px 0px;
  max-width: 1400px;
  margin: 0 auto;
  overflow: visible;
  min-height: calc(100vh - 200px);
}

/* заголовок */
.tr-header {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.tr-back-btn {
  padding: 10px 20px;
  background: white;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #002FA7;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tr-back-btn:hover {
  background: #f8faff;
  border-color: #002FA7;
  transform: translateY(-1px);
}

.tr-search-wrapper {
  flex: 1 1;
  max-width: 400px;
}

.tr-search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  background: white;
}

.tr-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

/* таблица */
.tr-table-wrapper {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  overflow-y: visible;
  position: relative;
}

.tr-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  font-size: 14px;
}

.tr-table thead th {
  background: #f8faff;
  padding: 16px 16px;
  text-align: left;
  font-weight: 600;
  color: #002FA7;
  border-bottom: 2px solid #e0e5ec;
  font-size: 14px;
  white-space: nowrap;
}

.tr-table tbody td {
  padding: 16px;
  border-bottom: 1px solid #eef2f6;
  vertical-align: middle;
}

.tr-row:hover {
  background: #fafbff;
}

/* номер */
.tr-number {
  width: 60px;
  color: #666;
  font-weight: 500;
  text-align: center;
}

/* преподавателль */
.tr-teacher-cell {
  min-width: 250px;
}

.tr-teacher-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.tr-teacher-name {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
}

/* ячейка с селоктором */
.tr-room-cell {
  min-width: 280px;
}

.tr-selector-wrapper {
  position: relative;
}

.tr-selector-btn {
  width: 100%;
  padding: 12px 16px;
  background: white;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s;
}

.tr-selector-btn:hover:not(:disabled) {
  border-color: #002FA7;
  background: #f8faff;
}

.tr-selector-btn.open {
  border-color: #002FA7;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background: #f8faff;
}

.tr-selector-btn:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

.tr-placeholder {
  color: #999;
}

.tr-selector-arrow {
  font-size: 12px;
  transition: transform 0.2s;
}

.tr-selector-btn.open .tr-selector-arrow {
  transform: rotate(180deg);
}

/* выпадающий список */
.tr-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #002FA7;
  border-top: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
}

.tr-dropdown-search {
  padding: 12px;
  border-bottom: 1px solid #e0e5ec;
}

.tr-dropdown-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  box-sizing: border-box;
}

.tr-dropdown-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.tr-dropdown-list {
  max-height: 260px;
  overflow-y: auto;
  padding: 8px 0;
}

.tr-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.tr-dropdown-item:hover {
  background-color: #f2f6fe;
}

.tr-dropdown-item.selected {
  background-color: #e8f0fe;
  color: #002FA7;
  font-weight: 500;
}

.tr-dropdown-empty {
  text-align: center;
  padding: 24px;
  color: #999;
  font-style: italic;
  font-size: 14px;
}

.tr-check {
  color: #002FA7;
  font-weight: bold;
}

.tr-saving {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #002FA7;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 8px;
  border-radius: 4px;
}

/* загрузка и ошибка */
.tr-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 40px;
  color: #666;
}

.tr-loading-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid #e0e5ec;
  border-top: 3px solid #002FA7;
  border-radius: 50%;
  animation: tr-spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes tr-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.tr-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #dc2626;
}

.tr-error button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #dc2626;
  padding: 0 8px;
}

.tr-error button:hover {
  opacity: 0.7;
}

.tr-empty {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  color: #888;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/md-components/TeacherToRoom.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB","sourcesContent":[".tr-container {\n  padding: 24px 0px;\n  max-width: 1400px;\n  margin: 0 auto;\n  overflow: visible;\n  min-height: calc(100vh - 200px);\n}\n\n/* заголовок */\n.tr-header {\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.tr-back-btn {\n  padding: 10px 20px;\n  background: white;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #002FA7;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tr-back-btn:hover {\n  background: #f8faff;\n  border-color: #002FA7;\n  transform: translateY(-1px);\n}\n\n.tr-search-wrapper {\n  flex: 1;\n  max-width: 400px;\n}\n\n.tr-search-input {\n  width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s;\n  background: white;\n}\n\n.tr-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n/* таблица */\n.tr-table-wrapper {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  overflow-x: auto;\n  overflow-y: visible;\n  position: relative;\n}\n\n.tr-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 12px;\n  font-size: 14px;\n}\n\n.tr-table thead th {\n  background: #f8faff;\n  padding: 16px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #002FA7;\n  border-bottom: 2px solid #e0e5ec;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.tr-table tbody td {\n  padding: 16px;\n  border-bottom: 1px solid #eef2f6;\n  vertical-align: middle;\n}\n\n.tr-row:hover {\n  background: #fafbff;\n}\n\n/* номер */\n.tr-number {\n  width: 60px;\n  color: #666;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* преподавателль */\n.tr-teacher-cell {\n  min-width: 250px;\n}\n\n.tr-teacher-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.tr-teacher-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n/* ячейка с селоктором */\n.tr-room-cell {\n  min-width: 280px;\n}\n\n.tr-selector-wrapper {\n  position: relative;\n}\n\n.tr-selector-btn {\n  width: 100%;\n  padding: 12px 16px;\n  background: white;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.2s;\n}\n\n.tr-selector-btn:hover:not(:disabled) {\n  border-color: #002FA7;\n  background: #f8faff;\n}\n\n.tr-selector-btn.open {\n  border-color: #002FA7;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  background: #f8faff;\n}\n\n.tr-selector-btn:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.tr-placeholder {\n  color: #999;\n}\n\n.tr-selector-arrow {\n  font-size: 12px;\n  transition: transform 0.2s;\n}\n\n.tr-selector-btn.open .tr-selector-arrow {\n  transform: rotate(180deg);\n}\n\n/* выпадающий список */\n.tr-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #002FA7;\n  border-top: none;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.tr-dropdown-search {\n  padding: 12px;\n  border-bottom: 1px solid #e0e5ec;\n}\n\n.tr-dropdown-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.tr-dropdown-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.tr-dropdown-list {\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.tr-dropdown-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n}\n\n.tr-dropdown-item:hover {\n  background-color: #f2f6fe;\n}\n\n.tr-dropdown-item.selected {\n  background-color: #e8f0fe;\n  color: #002FA7;\n  font-weight: 500;\n}\n\n.tr-dropdown-empty {\n  text-align: center;\n  padding: 24px;\n  color: #999;\n  font-style: italic;\n  font-size: 14px;\n}\n\n.tr-check {\n  color: #002FA7;\n  font-weight: bold;\n}\n\n.tr-saving {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  color: #002FA7;\n  font-weight: 500;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n/* загрузка и ошибка */\n.tr-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.tr-loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid #e0e5ec;\n  border-top: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: tr-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes tr-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.tr-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #dc2626;\n}\n\n.tr-error button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #dc2626;\n  padding: 0 8px;\n}\n\n.tr-error button:hover {\n  opacity: 0.7;\n}\n\n.tr-empty {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 12px;\n  color: #888;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
